import { render, staticRenderFns } from "./Props.vue?vue&type=template&id=17fd49ef&scoped=true&"
import script from "./Props.vue?vue&type=script&lang=js&"
export * from "./Props.vue?vue&type=script&lang=js&"
import style0 from "./Props.vue?vue&type=style&index=0&id=17fd49ef&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17fd49ef",
  null
  
)

export default component.exports